import { useEffect, useState } from "react";

export default function FloatWidget() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 640);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <div className="fixed bottom-5 right-4 z-40 flex flex-col gap-2.5 md:right-6">
      <a
        href="#hot"
        aria-label="跳到热评现场"
        className="grid h-11 w-11 items-center justify-center rounded-full bg-accent-400 text-primary-950 transition-transform hover:scale-105 cursor-pointer"
      >
        <i className="ri-chat-smile-3-line text-xl" aria-hidden="true" />
      </a>
      <button
        type="button"
        onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
        aria-label="回到顶部"
        className="grid h-11 w-11 items-center justify-center rounded-full border border-background-200 bg-background-50/95 text-foreground-900 backdrop-blur transition-transform hover:scale-105 cursor-pointer"
      >
        <i className="ri-arrow-up-line text-xl" aria-hidden="true" />
      </button>
    </div>
  );
}